module.exports = __webpack_public_path__ + "assets/normal/images/share3.a1d4e329.png";